import produce from 'immer';
// import {State, Actions} from './interfaces';
import {
  GET_ALL_INVOICES,
  GET_ALL_INVOICES_SUCCESS,
  GET_ALL_INVOICES_FAILED,
  GET_INVOICES_WITH_ID,
  GET_INVOICES_WITH_ID_FAILED,
  GET_INVOICES_WITH_ID_SUCCESS,
  UPDATE_INVOICES,
  UPDATE_INVOICES_SUCCESS,
  UPDATE_INVOICES_FAILED,
  CREATE_INVOICES,
  CREATE_INVOICES_SUCCESS,
  CREATE_INVOICES_FAILED,
  GET_INVOICES_LOGS,
  GET_INVOICES_LOGS_SUCCESS,
  GET_INVOICES_LOGS_FAILED,
  GET_INVOICES_FILE,
  GET_INVOICES_FILE_SUCCESS,
  GET_INVOICES_FILE_FAILED,
} from './constants';

export const initialState: State = {
  invoicesList: [],
  invoicesFile: null,
  allInvoicesList: [],
  logs: [],
  count: 0,
  loading: false,
  error: '',
};

export const InvoiceReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_ALL_INVOICES:
        draft.loading = true;
        break;
      case GET_ALL_INVOICES_SUCCESS:
        draft.allInvoicesList = action.data;
        draft.invoicesList = [];
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_ALL_INVOICES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_INVOICES_WITH_ID:
        draft.loading = true;
        break;
      case GET_INVOICES_WITH_ID_SUCCESS:
        draft.invoicesList = action.data;
        draft.loading = false;
        break;
      case GET_INVOICES_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_INVOICES_FILE:
        draft.loading = true;
        break;
      case GET_INVOICES_FILE_SUCCESS:
        draft.invoicesFile = action.data;
        draft.loading = false;
        break;
      case GET_INVOICES_FILE_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case UPDATE_INVOICES:
        draft.loading = true;
        break;
      case UPDATE_INVOICES_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_INVOICES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_INVOICES_LOGS:
        draft.loading = true;
        break;
      case GET_INVOICES_LOGS_SUCCESS:
        draft.logs = action.data;
        draft.loading = false;
        break;
      case GET_INVOICES_LOGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case CREATE_INVOICES:
        draft.loading = true;
        break;
      case CREATE_INVOICES_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_INVOICES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default InvoiceReducer;
